var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2041 21.9162C33.8201 21.6468 34.4111 21.3312 34.9726 20.9737C34.468 29.9095 27.062 37 18 37C8.61116 37 1 29.3888 1 20C1 10.938 8.09052 3.53202 17.0263 3.02742C16.6056 3.68817 16.2429 4.38967 15.9453 5.12478C15.4784 6.27829 15.8519 7.45033 16.1078 8.25359C16.1197 8.29081 16.1313 8.32724 16.1426 8.36283C16.3512 9.02231 16.5005 9.52095 16.5005 10C16.5005 10.5273 16.3587 11.068 16.1736 11.7444C16.1636 11.7809 16.1534 11.8181 16.143 11.856C15.8979 12.7457 15.5543 13.9932 16.0838 15.2041C16.5873 16.3556 17.6642 16.9264 18.4045 17.3187C18.4361 17.3355 18.4671 17.3519 18.4974 17.368C19.0734 17.6746 19.4893 17.9046 19.7941 18.2083C20.0949 18.5081 20.326 18.9239 20.636 19.5039C20.6525 19.5348 20.6693 19.5664 20.6865 19.5987C21.0795 20.3372 21.654 21.4169 22.7959 21.9162C23.4684 22.2103 24.1299 22.1865 24.7032 22.0608C25.2368 21.9438 25.7627 21.7212 26.1975 21.5372L26.2362 21.5209C26.9766 21.2077 27.5043 21 28 21C28.4957 21 29.0234 21.2077 29.7638 21.5209L29.8025 21.5372C30.2373 21.7212 30.7632 21.9438 31.2968 22.0608C31.8701 22.1865 32.5316 22.2103 33.2041 21.9162Z",
    fill: "#FFA564",
    stroke: "#642F08",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "#642F08"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.06641,
    y: 29.2617,
    width: 3,
    height: 4,
    rx: 1.5,
    transform: "rotate(-47.1745 9.06641 29.2617)",
    fill: "#642F08"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.37305,
    y: 18,
    width: 3,
    height: 4,
    rx: 1.5,
    transform: "rotate(5.34571 4.37305 18)",
    fill: "#642F08"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1113,
    y: 27,
    width: 3,
    height: 4,
    rx: 1.5,
    transform: "rotate(31.8734 24.1113 27)",
    fill: "#642F08"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4531,
    y: 21.168,
    width: 3,
    height: 4,
    rx: 1.5,
    transform: "rotate(31.8734 15.4531 21.168)",
    fill: "#642F08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0255 4.12279C29.1234 4.5286 29.0989 4.78545 29.0477 4.94939C28.9983 5.10731 28.9002 5.25614 28.7127 5.40956C28.2874 5.75756 27.5429 6.02329 26.4607 6.28424C24.7603 6.69426 22.9259 5.66446 22.5582 4.13929C22.4668 3.76016 22.5005 3.51816 22.5616 3.35622C22.6241 3.1903 22.7491 3.01918 22.9839 2.8409C23.4933 2.45417 24.3313 2.16873 25.4059 1.90962C27.0166 1.52124 28.6371 2.51211 29.0255 4.12279Z",
    fill: "#FFA564",
    stroke: "#642F08",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7236 7.72067C36.5232 7.92815 36.9211 8.33182 37.1191 8.80789C37.3373 9.33252 37.3677 10.0857 37.1223 11.0316C36.8563 12.0567 36.5006 12.9056 36.0532 13.4227C35.8405 13.6685 35.6305 13.8119 35.4236 13.8836C35.2233 13.953 34.9594 13.9787 34.5922 13.8834C33.8761 13.6976 33.402 13.2212 33.1372 12.5448C32.8622 11.8425 32.8248 10.933 33.0588 10.031C33.3134 9.04968 33.6805 8.37629 34.1001 8.00669C34.461 7.68871 34.9431 7.51815 35.7236 7.72067Z",
    fill: "#FFA564",
    stroke: "#642F08",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4902 12.6031L22.4903 12.603C22.7135 12.1967 22.8729 12.1432 22.9169 12.1303C23.0017 12.1056 23.1744 12.0979 23.553 12.2185C23.798 12.2966 24.0184 12.3869 24.2806 12.4943C24.4615 12.5684 24.6624 12.6507 24.905 12.7427C25.4334 12.9432 26.067 13.1469 26.7647 13.1943C27.2857 13.2296 27.5673 13.2912 27.7178 13.3509C27.759 13.3672 27.7819 13.3802 27.7927 13.3872C27.8068 13.422 27.8403 13.5384 27.8424 13.8413C27.8445 14.13 27.8205 14.4793 27.7879 14.9536C27.7837 15.0158 27.7793 15.0801 27.7747 15.1467C27.7465 15.5627 27.6466 15.7773 27.5622 15.892C27.4822 16.0006 27.3596 16.0968 27.1349 16.1732C26.6102 16.3516 25.8155 16.3403 24.6681 16.2624C23.9462 16.2134 23.1559 15.7117 22.6657 14.937C22.187 14.1803 22.0925 13.3269 22.4902 12.6031ZM27.8003 13.3926C27.8003 13.3926 27.8003 13.3926 27.8003 13.3926C27.8005 13.3927 27.8005 13.3928 27.8005 13.3928C27.8005 13.3928 27.8005 13.3927 27.8003 13.3926Z",
    fill: "#FFA564",
    stroke: "#642F08",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieIcon);
export default __webpack_public_path__ + "static/media/cookie-icon.27563cec7c4e937b90d8a56acf0e51f4.svg";
export { ForwardRef as ReactComponent };